import React, { useContext, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import axios from 'axios';
import { toast } from 'sonner';
import { RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';
import { getToken } from '../../services/tokenService';

const API = process.env.REACT_APP_BACKEND_URL;

export const isSuperAdmin = () => {
  try { return (JSON.parse(localStorage.getItem('user') || '{}').role || '').toLowerCase() === 'super_admin'; }
  catch { return false; }
};

export const useIsSuperAdmin = () => {
  const ctx = useContext(AuthContext);
  return (ctx?.user?.role || '').toLowerCase() === 'super_admin' || isSuperAdmin();
};

export const isRecu = (doc) => {
  const t = `${doc?.type || ''} ${doc?.categorie || ''} ${(doc?.tags || []).join(' ')}`.toLowerCase();
  return /recu/.test(t) && !!(doc?.souscription_id || doc?.recu_id);
};

export const RegenererRecuButton = ({ doc, membreId, onDone }) => {
  const [busy, setBusy] = useState(false);
  const superAdmin = useIsSuperAdmin();
  if (!superAdmin || !isRecu(doc)) return null;
  const cible = membreId ? `membre/${membreId}` : doc.souscription_id ? `souscription/${doc.souscription_id}` : `recu/${doc.recu_id}`;
  const lancer = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/api/recus/regeneration/${cible}`, {}, { headers: { Authorization: `Bearer ${getToken()}` } });
      toast.success(`${data.recus.length} reçu(s) du membre régénéré(s) avec le dispositif, le chantier et la période à jour`);
      onDone && onDone();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Échec de la régénération du reçu');
    } finally { setBusy(false); }
  };
  return (
    <Button variant="outline" size="sm" onClick={lancer} disabled={busy}
      className="border-orange-300 text-orange-700 hover:bg-orange-50" data-testid={`regenerer-recu-${doc.id}`}>
      <RefreshCw className={`h-4 w-4 mr-1 ${busy ? 'animate-spin' : ''}`} />Régénérer
    </Button>
  );
};
